export const INIT_STATE = 'INIT_STATE';
export const GET_PROD_GROUP_LIST = 'GET_PROD_GROUP_LIST';
export const GET_PROD_GROUP_LIST_SUCCESS = 'GET_PROD_GROUP_LIST_SUCCESS';
export const GET_PROD_GROUP_LIST_POP_SUCCESS = 'GET_PROD_GROUP_LIST_POP_SUCCESS';
export const GET_PROD_GROUP_CNT = 'GET_PROD_GROUP_CNT';
export const GET_PROD_GROUP_CNT_SUCCESS = 'GET_PROD_GROUP_CNT_SUCCESS';
export const EDIT_PROD_GROUP = 'EDIT_PROD_GROUP';
export const GET_COMMON_CODE_DTL_LIST = 'GET_COMMON_CODE_DTL_LIST';
export const PRDT_GET_COMMON_CODE_DTL_LIST_SUCCESS = 'PRDT_GET_COMMON_CODE_DTL_LIST_SUCCESS';
export const PRDT_SEARCH_BY_CHANNEL = 'PRDT_SEARCH_BY_CHANNEL';
export const PRDT_SEARCH_BY_CHANNEL_SUCCESS = 'PRDT_SEARCH_BY_CHANNEL_SUCCESS';
export const GET_PROD_LIST = 'GET_PROD_LIST';
export const GET_PROD_LIST_SUCCESS = 'GET_PROD_LIST_SUCCESS';
export const GET_PROD_LIST_POP = 'GET_PROD_LIST_POP';
export const GET_PROD_LIST_POP_SUCCESS = 'GET_PROD_LIST_POP_SUCCESS';
export const PRDT_SEARCH_BY_CHANNEL_POP = 'PRDT_SEARCH_BY_CHANNEL_POP';
export const PRDT_SEARCH_BY_CHANNEL_POP_SUCCESS = 'PRDT_SEARCH_BY_CHANNEL_POP_SUCCESS';
export const EDIT_PROD_GROUPM_MAPPING = 'EDIT_PROD_GROUPM_MAPPING';
export const GET_PROD_ORDER_LIST = 'GET_PROD_ORDER_LIST';
export const GET_PROD_ORDER_LIST_SUCCESS = 'GET_PROD_ORDER_LIST_SUCCESS';
export const GET_RIDER_SORT_LIST = 'GET_RIDER_SORT_LIST';
export const GET_RIDER_SORT_LIST_SUCCESS = 'GET_RIDER_SORT_LIST_SUCCESS';
export const GET_RIDER_SORT_LIST_CLEAR = 'GET_RIDER_SORT_LIST_CLEAR';
export const EDIT_RIDER_SORT_ORDER = 'EDIT_RIDER_SORT_ORDER';
export const GET_SALE_PROD_LIST = 'GET_SALE_PROD_LIST';
export const GET_SALE_PROD_LIST_SUCCESS = 'GET_SALE_PROD_LIST_SUCCESS';
export const GET_PROD_LIST_POP_CLEAR = 'GET_PROD_LIST_POP_CLEAR';
export const GET_PROD_SALE_IMPS_AGNC_REGED_LIST = 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST';
export const GET_PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR = 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR';
export const GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS = 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS';
export const GET_PRDT_BY_CHANNEL = 'GET_PRDT_BY_CHANNEL';
export const GET_PRDT_BY_CHANNEL_SUCCESS = 'GET_PRDT_BY_CHANNEL_SUCCESS';
export const GET_PROD_SALE_IMPS_AGNC_REG_LIST = 'GET_PROD_SALE_IMPS_AGNC_REG_LIST';
export const GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS = 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS';
export const GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR = 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR';
export const GET_PROD_SALE_QUIT_METHOD_CD = 'GET_PROD_SALE_QUIT_METHOD_CD';
export const GET_PROD_SALE_QUIT_METHOD_CD_SUCCESS = 'GET_PROD_SALE_QUIT_METHOD_CD_SUCCESS';
export const SAVE_PROD_SALE_IMPS_AGNC = 'SAVE_PROD_SALE_IMPS_AGNC';
export const PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR = 'PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR';
export const GET_PROD_SALE_IMPS_AGNC_REGED_LIST_MOD = 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_MOD';
export const GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS_MOD = 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS_MOD';
export const PROD_SALE_IMPS_AGNC_REGED_LIST_MOD_CLEAR = 'PROD_SALE_IMPS_AGNC_REGED_LIST_MOD_CLEAR';
export const GET_PROD_SALE_IMPS_AGNC_REG_LIST_MOD = 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_MOD';
export const GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS_MOD = 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS_MOD';
export const GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR_MOD = 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR_MOD';

export const initState = payload => {
    return { type: INIT_STATE, payload };
};
export const getProdGroupList = payload => {
    return { type: GET_PROD_GROUP_LIST, payload };
};
export const getProdGroupListSuccess = payload => {
    return { type: GET_PROD_GROUP_LIST_SUCCESS, payload };
};
export const getProdGroupListPopSuccess = payload => {
    return { type: GET_PROD_GROUP_LIST_POP_SUCCESS, payload };
};
export const getProdGroupCnt = payload => {
    return { type: GET_PROD_GROUP_CNT, payload };
};
export const getProdGroupCntSuccess = payload => {
    return { type: GET_PROD_GROUP_CNT_SUCCESS, payload };
};
export const editProdGroup = payload => {
    return { type: EDIT_PROD_GROUP, payload };
};
export const getCommonCodeDtlList = payload => {
    return { type: GET_COMMON_CODE_DTL_LIST, payload };
};
export const prdtGetCommonCodeDtlListSuccess = payload => {
    return { type: PRDT_GET_COMMON_CODE_DTL_LIST_SUCCESS, payload };
};
export const prdtSearchByChannel = payload => {
    return { type: PRDT_SEARCH_BY_CHANNEL, payload };
};
export const prdtSearchByChannelSuccess = payload => {
    return { type: PRDT_SEARCH_BY_CHANNEL_SUCCESS, payload };
};
export const getProdList = payload => {
    return { type: GET_PROD_LIST, payload };
};
export const getProdListSuccess = payload => {
    return { type: GET_PROD_LIST_SUCCESS, payload };
};
export const getProdListPop = payload => {
    return { type: GET_PROD_LIST_POP, payload };
};
export const getProdListPopSuccess = payload => {
    return { type: GET_PROD_LIST_POP_SUCCESS, payload };
};
export const getProdListPopClear = payload => {
    return { type: GET_PROD_LIST_POP_CLEAR, payload };
};
export const prdtSearchByChannelPop = payload => {
    return { type: PRDT_SEARCH_BY_CHANNEL_POP, payload };
};
export const prdtSearchByChannelPopSuccess = payload => {
    return { type: PRDT_SEARCH_BY_CHANNEL_POP_SUCCESS, payload };
};
export const editProdGroupMapping = payload => {
    return { type: EDIT_PROD_GROUPM_MAPPING, payload };
};
export const getProdOrderList = payload => {
    return { type: GET_PROD_ORDER_LIST, payload };
};
export const getProdOrderListSuccess = payload => {
    return { type: GET_PROD_ORDER_LIST_SUCCESS, payload };
};
export const getRiderSortList = payload => {
    return { type: GET_RIDER_SORT_LIST, payload };
};
export const getRiderSortListSuccess = payload => {
    return { type: GET_RIDER_SORT_LIST_SUCCESS, payload };
};
export const getRiderSortListClear = payload => {
    return { type: GET_RIDER_SORT_LIST_CLEAR, payload };
};
export const editRiderSortOrder = payload => {
    return { type: EDIT_RIDER_SORT_ORDER, payload };
};
export const getSaleProdList = payload => {
    return { type: GET_SALE_PROD_LIST, payload };
};
export const getSaleProdListSuccess = payload => {
    return { type: GET_SALE_PROD_LIST_SUCCESS, payload };
};
export const getProdSaleImpsAgncRegedList = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REGED_LIST, payload };
};
export const getProdSaleImpsAgncRegedListClear = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR, payload };
};
export const getProdSaleImpsAgncRegedListSuccess = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS, payload };
};
export const getProdSaleImpsAgncRegedListMod = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REGED_LIST_MOD, payload };
};
export const getProdSaleImpsAgncRegedListSuccessMod = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS_MOD, payload };
};
export const getPrdtByChannel = payload => {
    return { type: GET_PRDT_BY_CHANNEL, payload };
};
export const getPrdtByChannelSuccess = payload => {
    return { type: GET_PRDT_BY_CHANNEL_SUCCESS, payload };
};
export const getProdSaleImpsAgncRegList = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REG_LIST, payload };
};
export const getProdSaleImpsAgncRegListSuccess = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS, payload };
};
export const getProdSaleImpsAgncRegListClear = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR, payload };
};
export const getProdSaleQuitMethodCd = payload => {
    return { type: GET_PROD_SALE_QUIT_METHOD_CD, payload };
};
export const getProdSaleQuitMethodCdSuccess = payload => {
    return { type: GET_PROD_SALE_QUIT_METHOD_CD_SUCCESS, payload };
};
export const saveProdSaleImpsAgnc = payload => {
    return { type: SAVE_PROD_SALE_IMPS_AGNC, payload };
};
export const prodSaleImpsAgncRegedListClear = payload => {
    return { type: PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR, payload };
};
export const prodSaleImpsAgncRegedListModClear = payload => {
    return { type: PROD_SALE_IMPS_AGNC_REGED_LIST_MOD_CLEAR, payload };
};
export const getProdSaleImpsAgncRegListMod = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REG_LIST_MOD, payload };
};
export const getProdSaleImpsAgncRegListSuccessMod = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS_MOD, payload };
};
export const getProdSaleImpsAgncRegListClearMod = payload => {
    return { type: GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR_MOD, payload };
};